import { useRoute } from 'vue-router'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'

// prettier-ignore
const rails_url = (slug=null) => {
  const route = useRoute()
  const workspaceStore = useWorkspaceStore()
  slug = slug || route?.params?.slug || workspaceStore.current?.subdomain

  return import.meta.env.VITE_VENTURE360_API_URL
    .replace('://api.', '://' + slug + '.')
    .replace('/v3', '')
}

export { rails_url }
